export default "__VITE_ASSET__6ff5e2d9__"